// import enLocale from 'element-ui/lib/locale/lang/en'
export const lang = {
//   ...enLocale,
  'Sign_in_title': 'Sign in',
  'Sign_in': 'Sign in',
  'Register': 'Register',
  'login in': 'login in',
  // 注册
  'The password should be six digits': 'The password should be six digits',//密码应为6位
  'Please enter the account': 'Please enter the account',
  'please input your account name': 'please input your account name',
  'Register_title': 'Register',
  'Please_enter_account': 'Please enter account',
  'Please_input_a_password': 'Please input password',
  'Please input new password': 'Please input new password',
  'Please_input_a_password_again': 'Please input password again',
  'Please-enter-verification-code': 'Enter verification code',
  'clickChange': 'clickChange',
  'Existing-account': 'Existing account',
  'Failed to get image captcha': 'Failed to get image captcha',
  // 菜单列表
  'Equipment Management': `Equipment Management`,
  'Battery Management':'Battery Management',
  'Swapping Station Management': 'Swapping Station Management',
  'Order Management': 'Order Management',
  'New Card Order': 'New Card Order',
  'Renewal Order': 'Renewal Order',
  'Selection Certificate':'Selection Certificate',
  'User Phone':'User Phone',
  'user':'user',
  'Swapping Order': 'Swapping Order',
  'Agent Management': 'Agent Management',//代理商管理
  'Organization Management': 'Organization Management',
  'User Management': 'User Management',
  'Card Management': 'Card Management',
  'Edit battery ownership':'Edit battery ownership',
  // 电池管理
  'Equipment Number':'Equipment Number',
  'Please enter device number':'Please enter device number/communication board number/housing number/battery QR code',
  'Attribution Type':'Attribution Type',
  'Attribution Object':'Attribution Object',
  'Lock Cause':'Lock Cause',
  'Attribution Object Type':'Attribution Object Type',
  'Please enter your mobile phone number':'Please enter your mobile phone number',
  'Please enter the name of the switchboard':'Please enter the name of the switchboard',
  'Attribution Subobject':'Attribution Subobject',
  'Please enter the voucher number': 'Please enter the voucher number',
  'Port Number': 'Port Number',
  'Communication Board Number':'Communication Board Number',
  'Attribution information':'Attribution information',
  // 换电柜管理
  'Device ID': 'Device ID',
  'Please-enter-the-device-number': 'Please enter the device number',
  'Equipment name': 'Equipment name',//设备名称
  'Please-enter-the-device-name': 'Please enter the device name',
  'Agent/Store': 'Agent/Store:',
  'Service status': 'Service status',
  'Assign the change cabinet': 'Assign the change cabinet',
  'Select time range': 'Select time range',
  'Please select equipmente': 'Please select equipmente',
  'Equipment number': 'Equipment number',//设备编号
  // 换电柜编辑
  'Equipment qr code': 'Equipment qr code',
  'Delivery address': 'Google map location',//投放地址
  'Please select the delivery address': 'Please select the google map location',
  'Detailed address': 'Detailed address',
  'Please enter the detailed address': 'Please enter the detailed address',
  'Replaceable battery spec': 'Replaceable battery spec',//可换电池规格
  'Replaceable battery material': 'Replaceable battery material',//可换电池材料
  'Battery collection conditions': 'Battery collection conditions',//领取电池条件
  'The actual replaceable battery in the cabinet is not less than': 'The actual replaceable battery in the cabinet is not less than',//柜内实际可换电池不少于
  'Return of battery conditions': 'Return of battery conditions',//退还电池条件
  'There should be no less space in the cabinet': 'There should be no less space in the cabinet',  //柜内可用空格口不少于
  'Business hours': 'Business hours',//营业时间
  'Real picture': 'Real picture',//实景图
  'Number of replaceable batteries': 'Number of replaceable batteries',//可换电池数量
  'Equipment version': 'Equipment version',
  'Protocol version': 'Protocol version',//协议版本
  'Equipment status': 'Equipment status',
  'Please upload pictures below 2m': 'Please upload pictures below 2m',
  'Please enter the equipment name': 'Please enter the equipment name',//请输入设备名称
  'Please enter the delivery address': 'Please enter the google map location',//请输入投放地址
  'Please select a replaceable battery specification': 'Please select a replaceable battery specification',//请选择可换电池规格
  'Please select the equipment version': 'Please select the equipment version',//请选择设备版本
  'Please select the protocol version': 'Please select the protocol version',//请选择协议版本
  'The number of exchangeable batteries is illegal': 'The number of exchangeable batteries is illegal',//可换电池数量参数非法！
  'Make sure to deactivate the equipment': 'Make sure to deactivate the equipment',//确定停用该设备
  'Determine the device': 'Determine the device ?',//确定启用该设备
  'unselected': 'unselected',//未选择
  'bound': 'bound',//绑定
  'unbound': 'unbound',
  'Replace QR code': 'Replace QR code',
  'Binding QR code': 'Binding QR code',
  'View QR code': 'View QR code',
  'Wait to leave factory':'Wait to leave factory',
  // 换电柜详情
  'version': 'version',
  'Power status of equipment': 'Power status of equipment',//设备通电状态：
  'Equipment service status': 'Equipment service status',//
  'Used electricity': 'Used electricity',//已使用电量
  'View equipment snapshot': 'View equipment snapshot',//查看设备快照
  'View the sending request record': 'View the sending request record',//查看发送请求记录
  'sending request record': 'sending request record',//发送请求记录
  'View the ops operation record': 'View the ops operation record',//查看运维操作记录
  'electricity': 'Power On',//通电
  'Power cut': 'Power Cut',//断电
  'Port number': 'Port number',//端口编号
  'Port state': 'Port state',//端口状态
  'Port current/voltage': 'Port current/voltage',//端口电流/电压
  'voltage': 'voltage',
  'current': 'current',
  'Battery power board temperature': 'Battery power board temperature',
  'Discharge MOS temperature':'Discharge MOS temperature',
  'Charge MOS temperature':'Charge MOS temperature',
  'Max battery temperature':'Max battery temperature',
  'Min battery temperature':'Min battery temperature',
  'voltage difference':'voltage difference',
  'Battery status': 'Battery status',
  'Port service status': 'Port service status',//端口服务状态
  'Port charged amount/Charging time': 'Port charged amount/Charging time',//端口已充电量/充电时长
  'Charged amount': 'Charged amount',//已充电量
  'Battery current/voltage/Voltage difference': 'Battery current/voltage/Voltage difference', //电池电流/电压/压差
  'Battery Power/Health level': 'Battery Power/Health level',//电池电量/健康程度
  'Health level': 'Health level',//健康状态
  'Battery specification':'Battery specification',
  'Port battery SN': 'Port battery SN',
  'The highest battery temperature/lowest': 'The highest battery temperature/lowest',//电池温度最高/最低
  'Max battery temperature': 'Max battery temperature',// 电池最高温度
  'Min battery temperature': 'Min battery temperature',// 电池最低温度
  'minutes': 'minutes',
  'MOS Temperature charging/discharge': 'MOS Temperature charging/discharge',//MOS温度充电/放电
  'Charging temperature': 'Charging temperature',//充电温度
  'Discharge temperature': 'Discharge temperature',// 放电温度
  'Battery cycle number': 'Battery cycle number',//电池循环次数
  'State of cabinet door': 'State of cabinet door',//柜门状态
  'Refresh time': 'Refresh time',//刷新时间
  'Monomer voltage': 'Monomer voltage',//单体电压
  'To view': 'To view',//查看
  'refresh': 'refresh',
  'Please specify the reason for disabling the port:': 'Please specify the reason for disabling the port:',//请输入停用原因
  'View cell voltage': 'View cell voltage',//查看单体电压
  'time': 'time',
  'Cell voltage number': 'Cell voltage number',//单体电压编号
  'Receiving time': 'Receiving time',//接收时间
  'Wrong QR code': 'Wrong QR code',//Wrong QR code
  'Make sure to deactivate the port': 'Make sure to deactivate the port',//确定停用该端口
  'Whether to confirm the power cut': 'Whether to confirm the power cut',//是否确定断电
  'Whether determine the sync upload the qr code': 'Whether determine the sync upload the qr code',//是否确定同步上传二维码
  'No': 'No',//号
  'Whether to determine the power': 'Whether to determine the power',//是否确定断电\
  'Whether to confirm the power': 'Whether to confirm the power',//是否确定通电
  'is sure open cupboard door': 'is sure open cupboard door',//号柜门是否确定打开
  'Charging pile management': 'Charging pile management',//充电桩管理
  'Equipment snapshot': 'Equipment snapshot',//设备快照
  'Charging charge station management': 'Charging charge station management',//充电柜管理
  'Change charge station management': 'Change charge station management',//换电柜管理
  'Equipment snapshot number': 'Equipment snapshot number',//设备快照编号
  'Port current': 'Port current',//端口电流
  'Port voltage': 'Port voltage',//端口电压
  'battery SN': 'battery SN',//电池通讯板号
  'Battery Power': 'Battery Power',//电池电量
  'Battery current': 'Battery current',//电池电流
  'no data': 'no data',//暂无数据
  'The': 'The',//第
  'page': 'page',//页
  'error message':'error message',
  'total':'total',
  'The current page': 'The current page',//当前页
  'item': 'item',//条
  'Jump to': 'Jump to',//跳转到
  'Previous page': 'Previous page',//上一页
  'Next page': 'Next page',//下一页
  'Not shown': 'Not shown',//未展示
  'type': 'type',//类型
  // 发送请求记录
  'Request number': 'Request number',//请求编号
  'Send time': 'Send time',//发送时间
  'content': 'content',//内容
  'operator': 'operator',//操作人
  'status': 'status',//
  'all': 'all',//全部
  'All': 'All',//全部
  'Old Charging Service': 'Old Charging Service',//旧充电服务
  'New Charging Services': 'New Charging Services',//新充电服务
  'Charging cabinet charging service': 'Charging cabinet charging service',//充电柜充电服务
  'Charging cabinet service door reminder': 'Charging cabinet service door reminder',//充电柜服务开门提醒
  'Charging cabinet service user additional operation': 'Charging cabinet service user additional operation',//充电柜服务用户额外操作
  'Remote upgrade of cabinet': 'Remote upgrade of cabinet',//柜子远程升级
  'Get the battery': 'Get the battery',//领取电池
  'Receive batteries for additional operations': 'Receive batteries for additional operations',//领取电池额外操作
  'Return battery': 'Return battery',//退还电池
  'Return the battery for additional operation': 'Return the battery for additional operation',//退还电池额外操作
  // 运维操作记录
  'Operation and maintenance records': 'Operation and maintenance records',//运维操作记录
  'Operation reason': 'Operation reason',//操作原因
  'Open the door': 'Open the door',//开门
  'Close the door': 'Close the door',//关门
  'In the battery': 'In the battery',//放入电池
  'Take out the battery': 'Take out the battery',//取出电池
//
  'Communication board number': 'SN',
  'Equipment type': 'Equipment type',
  'Location address': 'Location address',
  'Agent': 'Agent',
  'Device power state': 'Device power state',
  'Battery used': 'Battery used',
  'Number of batteries': 'Number of batteries',
  'Device Status': 'Device Status',
//
  'Number of unplugged batteries': 'Number of unplugged batteries',
// 开卡,卡管理
  'Card number': 'Card number',//卡号
  'Choose battery': 'Choose battery',
  'Product number': 'Product number',//商品编号
  'Product name': 'Product name',
  'Battery spec': 'Battery spec',
  'Commodity price': 'Commodity price',//商品单价
  'Deposit': 'Deposit',
  'Effective time': 'Effective time',//有效时长
  'Product types': 'Product types',//商品类型
  'Payment details': 'Payment details',
  'Enter or read the card number': 'Enter or read the card number',
  'Please select an organization': 'Please select an organization',
  'Enter Card password': 'Enter Card password',
  'Choose a package': 'Choose a package',//选择套餐
  'Number of replacement cards': 'Number of replacement cards',
  'Card opening details': 'Card opening details',
  'Battery Number': 'Battery Number',
  'Set meal': 'Set meal',
  'Effective Total Time': 'Effective Total Time',
  'Amount': 'Amount',//金额
  'Total Rent': 'Total Rent',
  'Time': 'Time',
  'Card status': 'Card status',
  'The remaining number of days': 'The remaining number of days',//剩余天数
  'Current effective time': 'Current effective time',
  'Username': 'Username',
  'Please input name': 'Please input name',
  'User contact': 'User contact',//用户联系方式
  'Contact details': 'Contact details',//联系方式
  'Activation time': 'Activation time',
  'Operating': 'Operating',//操作
  'Reset card password': 'Reset card password',
  'Open card': 'Open card',
  'Please select battery spec': 'Please select battery spec',
  ' Please select card status': ' Please select card status',
  'Edit user': 'Edit user',
  'Prompt': 'Prompt',//提示
  'Please enter the reset card password': 'Please enter the reset card password',
  'Please enter the reset card password again': 'Please enter the reset card password again',
  'Password at least 6 characters': 'Password at least 6 characters',
//开卡message
  'The password cannot be empty': 'The password cannot be empty',
  'account cannot be empty': 'account cannot be empty',//账号不能为空
  'Please select package and battery': 'Please select package and battery', //请选择套餐和电池
  'Please select agent': 'Please select your agent',//请选择所属代理商
// 卡管理详情
  'User Info': 'User Info',//用户信息
  'Organization': 'Organization',//所属组织
  'Document No': 'Document No',
  'Product specifications': 'Product specifications',//商品规格
  'valid date': 'valid date',
  'Report loss/recovery': 'Report loss/recovery',
  'Attribution': 'Attribution',
  'Status': 'Status',
  'Switch state': 'Switch state',
  'Whether to confirm that the switching status is': 'Whether to confirm that the switching status is',//是否确认切换状态为
  'Loss reporting': 'Loss reporting',
  'restore': 'restore',
  'Whether to confirm': 'Whether to confirm',//是否确认
  'Current battery spec': 'Current battery spec',
// 续费
  'Credential status': 'Credential status',
  'Number of replace ment cards': 'Number of replace ment cards',
  'Renewal Details': 'Renewal Details',//续费详情
// 用户管理
  'Account number': 'Account number',
  'Please enter your account number': 'Please enter your account number',
  'Permission': 'Permission',
  'Please select a permission': 'Please select a permission',
  'Please enter the binding card number': 'Please enter the binding card number',
  'Assign users': 'Assign users',
  'Add': 'Add',
  'Store': 'Store',
  'Setup time': 'Setup time',//创建时间
  'Move out': 'Move out',
  'Modify permissions': 'Modify permissions',
  'Account': 'Account',
  'Password': 'Password',
  'Please enter the password': 'Please enter the password',
  'Confirm password': 'Confirm password',
  'Please enter the password again': 'Please enter the password again',
  'Please select an assignment object': 'Please select an assignment object',
  'Change user name': 'Change user name',
  'Are you sure to move the user out of the agency or store': 'Are you sure to move the user out of the agency or store',
  'Add account': 'Add account',
  'Edit permissions': 'Edit permissions',
  'No permission': 'No permission',
  'All permissions': 'All permissions',
  'Please enter user name': 'Please enter user name',
  'Please select equipment': 'Please select equipment',
// 代理商管理
  'Please input Agent/Store': 'Please input Agent/Store',//请输入代理商
  'Organization number': 'Organization number:',//组织编号
  'Please enter the organization number': 'Please enter the organization number',//请输入组织编号
  'Associated account': 'Associated account:',//关联账号：
  'Please enter the associated account': 'Please enter the associated account',//请输入关联账号
  'Character': 'Character:',//角色
  'please choose Character': 'please choose Character',//请选择角色
  'Add agent': 'Add agent',//新增代理商
  'Agent/Store name': 'Agent/Store name',//名称
  'Area': 'Area',//地区
  'Affiliated agent': 'Affiliated agent',//所属代理商
  'Delete': 'Delete',//删除
  'New store': 'New store',//新建门店
  'Agent name': 'Agent name',//门店名称
  'Agent area': 'Agent area',//代理商地区
  'Agent address ': 'Agent address',//代理商地址
  'Store name': 'Store name',//门店地址
  'Please enter the store name': 'Please enter the store name',//
  'Store area': 'Store area',//门店地区
  'Store address': 'Store address',//门店地址
  'Please enter the store address': 'Please enter the store address',//请输入门店地址
  'Please enter the agent name': 'Please enter the agent name',//请输入代理商名称
  'please choose Agent area': 'please choose Agent area',//请输入代理商地区
  'Please enter the agent address': 'Please enter the agent address',//请输入代理商地址
  'Whether confirm to delete this agent/stores': 'Whether confirm to delete this agent/stores',//是否确认删除此代理商/门店
  'The agent name cannot be empty': 'The agent name cannot be empty',//代理商名称不能为空
  'Associated account cannot be empty': 'Associated account cannot be empty',//关联账号不能为空
  'Edit store': 'Edit store',//编辑门店
  'Edit agent': 'Edit agent',//编辑代理商
  'agent': 'agent',//代理商呢
  'store': 'store',//门店
// 换电订单
  'Order Details': 'Order Details',//订单详情
  'Completion progress': 'Completion progress',//完成进度
  'Order status': 'Order status',//订单状态
  'Please select order status': 'Please select order status',//请选择订单状态
  'To be paid': 'To be paid',//代付款
  'Payment has been': 'Payment has been',//已付款
  'finished': 'finished',//已完成
  'closed': 'closed',//已关闭
  'Order time': 'Order time:',//下单时间
  'Device address': 'Device address',//设备地址
  'Switch cabinet number': 'Switch cabinet number',//换电柜编号
  'Name of switch cabinet': 'Changing cabinet switch cabinet',//换电柜名称
  'Name of': 'Changing cabinet',
  'switch cabinet': 'switch cabinet',
  'Swap in and swap': 'Swap in and swap',
  'out Battery SN': 'out Battery SN',
  'Swap in and swap out Battery SN': 'Swap in and swap out Battery SN',//换入换出电池通讯板号
  'Switch in and switch': 'Switch in and switch',
  'out of the cabinet door': 'out of the cabinet door',
  'Switch in and switch out of the cabinet door': 'Switch in and switch out of the cabinet door',//换入换出柜门
  'Swap in and': 'Swap in and',
  'out of power': 'out of power',
  'Swap in and out of power': 'Swap in and out of power',//换入换出电量
  'Swap in and swap out health status': 'Swap in and swap out health status',//换入换出健康状态
  'lump sum': 'lump sum',//总额
  'View order details': 'View order details',//查看订单详情
  'phone': 'Phone',
  'Total amount payable': 'Total amount payable',//应付总额
  'Actual amount': 'Actual amount',//实付总额
  'Commodity information': 'Commodity information',//商品信息
  'product name': 'product name',//商品名称
  'Suborder status': 'Suborder status',//子订单状态
  'consignor': 'consignor',//发货人
  'Delivery time': 'Delivery time',//发货时间
  'Order information': 'Order information',//订单信息
  'Time of payment': 'Time of payment',//付款时间
  'Terms of payment': 'Terms of payment',//付款方式
  'Completion time': 'Completion time',//完成时间
  'Single amount payable': 'Single amount payable',//单次应付金额
  'Total number of stages': 'Total number of stages',//分期总数
  'Stage interval': 'Stage interval',//分期间隔时间
  'Staging Details': 'Staging Details',//分期详情
  'Staging number': 'Staging number',//分期序号
  'Last payment date': 'Last payment date',//最后付款日
  'Actual payment time': 'Actual payment time',//实际付款时间
  'Payment method': 'Payment method',//付款方式
  'The fashionable details': 'The fashionable details',//分账详情
  'Close ledger': 'Close ledger',//关闭分账
  'Please enter the reason for closing the ledger': 'Please enter the reason for closing the ledger',//请输入关闭分账原因
  'Cause of failure': 'Cause of failure',//失败原因
  'Please enter the reason for closing': 'Please enter the reason for closing',//请输入关闭原因
  'Please enter 1-30 characters': 'Please enter 1-30 characters',//请输入1-30个字符
  'Distributing record number': 'Distributing record number',//分账记录编号
  'Description of itemized goods': 'Description of itemized goods',//分账商品描述
  'Name of ledger organization': 'Name of ledger organization',//分账组织名称
  'Type of ledger account': 'Type of ledger account',//分账账户类型
  'Record setup time': 'Record setup time',//记录创建时间
  'Enterprise Alipay account': 'Enterprise Alipay account',//企业支付宝账户
  'Second-level inbound merchants': 'Second-level inbound merchants',//二级进件商户
  'Alipay login account': 'Alipay login account',//支付宝登录账户
  'Undivided account': 'Undivided account',//待分账
  'In ledger': 'In ledger',//分账中
  'Distributed account': 'Distributed account',//已分账
  'Collecting a failure': 'Collecting a failure',//分账失败
  'To be settled': 'To be settled',//待结算
  'In settlement': 'In settlement',//结算中
  'settled': 'settled',//已结算
  'Settlement failures': 'Settlement failures',//结算失败
  'Close allotment failed': 'Close allotment failed',//关闭分账失败
  'phase': 'phase',//期
  'Service type': 'Service type',//服务类型
  'In electricity': 'In electricity',//换电费
  'preferential': 'preferential',//优惠
  'Power Changing Service': 'Power Changing Service',//换电服务
  'Swap out': 'Swap out',//换出
  'Swap in': 'Swap in',//换入
  'Amount of goods': 'Amount of goods',//商品数量
  'Amounts payable': 'Amounts payable',//应付金额
  'The amount actually paid': 'The amount actually paid',//实付金额
  'Total cost': 'Total cost',//总费用
// 开卡订单详情
  'Card opening order details': 'Card opening order details',//
  'Battery unit price': 'Battery unit price',//电池单价
  'Exit failure': 'Exit failure',//退出失败
  '三元锂': 'Ternary lithium',//三元锂
  '磷酸铁锂': 'Lithium iron phosphate',//磷酸铁锂
  'energized': 'energized',//已通电
  'Power out': 'Power out',//已断电
  'In the electricity service': 'In the electricity service',//换电服务
  'Operational records': 'Operational records',//运维记录
  'In electrical service user additional operations': 'In electrical service user additional operations',//换电服务用户额外操作
  'System request': 'System request',//系统请求
  'Offline in electricity': 'Offline in electricity',//离线换电
  'The query results information offline in electricity': 'The query results information offline in electricity',//查询离线换电结果信息
  'Relay on': 'Relay on',//继电器开启
  'Relay off': 'Relay off',//继电器关闭
  'failure': 'Failure',//失败
  'Success': 'Success',//失败
  'In process': 'In process',//处理中
  'battery': 'battery',// 电池
  'health':'Health',// 健康
  'Check progress': 'Check progress',//查看进度
  'Hardware type':'Hardware type',
  'At buzzer':'At buzzer',
  'Not buzzer':'Not buzzer',
  'Lock':'Lock',
  'Look State':'Look State',
  'Switching state':'Switching state',
  'Not Lock':'Not Lock',
  'name': 'name',
  'In the electric cabinet': 'In the electric cabinet',//换电柜
  'Charging port': 'Charging port',//充电口
  'disconnected': 'disconnected',//已断开连接
  'The battery is not plugged in': 'The battery is not plugged in',//没有插上电池
  'Battery charging': 'Battery charging',//电池充电中
  'Battery charging switch':'Battery charging switch',
  'Battery discharge switch':'Battery discharge switch',
  'The battery is fully charged': 'The battery is fully charged',//电池已充满
  'Has been on the battery': 'Has been on the battery',//已经插上电池
  'Charging on': 'Charging on',//充电开启中
  'Battery failure': 'Battery failure',//电池故障
  'Unable to read port state': 'Unable to read port state',//无法读取端口状态
  'open': 'open',//开启
  'Shut down': 'Shut down',//关闭
  'Offline payment': 'Offline payment',//线下支付
  'Remaining Completion Time': 'Remaining Completion Time',//剩余完成时间
  'sec': 'sec',//秒
  'Cabinet door': 'Cabinet door',//柜门
  'opened': 'opened',//已打开
  'opening': 'opening',//正在打开
  'Put in the battery and close the cabinet door': 'Put in the battery and close the cabinet door',//请放入电池并关闭柜门
  'Make sure the battery is plugged in': 'Make sure the battery is plugged in',//请务必确认插好电池
  'Please remove the battery and close the cabinet door': 'Please remove the battery and close the cabinet door',//请取出电池并关闭柜门
  'Successful, confirm return': 'Successful, confirm return',//已成功，确认返回
  'Failed, confirm return': 'Failed, confirm return',//已失败，确认返回
  'In the electric card': 'In the electric card',//换电卡
  'Battery holding certificate': 'Battery holding certificate',//电池持有凭证
  'login number': 'login number',
  'NAME': 'NAME',
  'User Number': 'User Number',
//   {{$t('lang.Register_title')}}
// $t('lang.Register_title')
// this.$t('lang.all')
  'user name': 'User name',
  'selected location': 'selected location',
  'Online payment': 'Online payment',


//   {{$t('lang.Register_title')}}
// $t('lang.Register_title')


//开卡订单
  'Order number': 'Order number',//订单编号
  'Order number input': 'Please enter the order number',
  'Total payment amount': 'Total payment amount',


  // 公共
  'Please choose': 'Please choose',
  'Details': 'Details',
  'Look Details': 'Details',
  'Edit': 'Edit',
  'new': 'new',
  'Inquire': 'Inquire',//查询
  'Distribution': 'Distribution',
  'View Details': 'View Details',
  'Import':'Import',
  'Import File':'Import File',
  'Add File':'Add File',
// 新增公共
  'day': 'day',
  'Quantity': 'Quantity',//数量
  'Rent': 'Rent',
  'Total amount': 'Total amount',//总额
  'Card password': 'Card password',
  'Name': 'Name',//姓名
  'Cancel': 'Cancel',
  'Confirm': 'Confirm',
  'Battery': 'Battery',
  'Successful': 'Successful',
  'start time': 'start time',
  'end time': 'end time',
  'Renew': 'Renew',
  'The two passwords do not match': 'The two passwords do not match',
  'Successfully reset!': 'Successfully reset!',
  'Edit success': 'Edit success',
  'Confirm deletion?': 'Confirm deletion?',
  'Logon has timed out. Please login again': 'Logon has timed out. Please login again',
  'back': 'back',
  'Query failed': 'Query failed',//查询失败
  'Log out': 'Log out',//退出登录
  // 下拉
  'available': 'available',
  'unavailable': 'unavailable',
  'Enable': 'Enabled',//启用
  'unenable': 'Disabled',//停用
  'Change the password': 'Change the password',
  'prompt': 'prompt',
  'Modify Password': 'Modify Password',
  'The password can only Numbers or letters': 'The password can only Numbers or letters',
  'Changing cabinet': 'Changing cabinet',
  'Charging cabinet': 'Charging cabinet',
  'times': 'times',
  'Measured card': 'Measured card',
  'Timer card': 'Timer card',
  'Available times': 'Available times',
  'days': 'days',
  'Package': 'Package',
  'Userinfo': 'Userinfo',
  'Charging time': 'Charging time',
  'Voltage difference': 'Voltage difference',
  'Change status1': 'Disable Port',
  'Change status0': 'Enable Port',
  'Are you sure you want to enable this port?': 'Are you sure you want to enable this port?',
  'Export': 'Export',
  'Whether to confirm export': 'Whether to confirm export',
  'Being exported': 'Being exported',
  'Export successful': 'Export successful',
  'Task type': 'Task type',
  'File name': 'File name',
  'Task status': 'Task status',
  'Download link': 'Download link',
  'Device snapshot data export': 'Device snapshot data export',
  'Export of order data for power exchange': 'Export of order data for power exchange',
  'Export of SMS data statistics': 'Export of SMS data statistics',
  'Sending SMS log data export': 'Sending SMS log data export',
  'User rights scheme export': 'User rights scheme export',
  'User battery data export': 'User battery data export',
  'Battery mileage data export': 'Battery mileage data export',
  'Export of equipment exception records': 'Export of equipment exception records',
  'Abnormal export of the charging status of the charging port': 'Abnormal export of the charging status of the charging port',
  'Battery idle state export': 'Battery idle state export',
  'Application for exchange order export': 'Application for exchange order export',
  'Instalment order export': 'Instalment order export',
  'Charging order export for charging cabinets': 'Charging order export for charging cabinets',
  'Battery snapshot data export': 'Battery snapshot data export',
  'Electric vehicle information export': 'Electric vehicle information export',
  'Voucher information export': 'Voucher information export',
  'Export of electricity exchange card orders': 'Export of electricity exchange card orders',
  'User information export': 'User information export',
  'Return order export': 'Return order export',
  'Master device information export': 'Master device information export',
  'Battery flow record export': 'Battery flow record export',
  'User invitation record export': 'User invitation record export',
  'Pending': 'Pending',
  'New card order export': 'New card order export',
  'Renewal order export': 'Renewal order export',
  'Swapping station management export': 'Swapping station management export',
  'Swapping order export': 'Swapping order export',
  'Download': 'Download',
  'Exporting Task': 'Exporting Task',
  'In the electric timer card': 'In the electric timer card',
  'In the electric measured card': 'In the electric measured card',
  'Vehicle Management': 'Vehicle Management',
  'Central Control Number': 'Central Control Number',
  'ECU Manufacturer': 'ECU Manufacturer',
  'Equipment Type': 'Equipment Type',
  'Please select the equipment type': 'Please select the equipment type',
  'Equipment Number': 'Equipment Number',
  'Please enter the equipment number': 'Please enter the equipment number',
  'Vehicle Frame Number': 'Vehicle Frame Number',
  'Please enter the vehicle Frame Number': 'Please enter the vehicle Frame Number',
  'User ID': 'User ID',
  'Please enter the user ID': 'Please enter the user ID',
  'Linked Account': 'Linked Account',
  'Please enter the linked Account': 'Please enter the linked Account',
  'Equipment State': 'Equipment State',
  'Import Time': 'Import Time',
  'Activate': 'Activate',
  'Vehicle Number': 'Vehicle Number',
  'Associated Account': 'Associated Account',
  'Central Control Information': 'Central Control Information',
  'Total Mileage': 'Total Mileage',
  'Central Control State': 'Central Control State',
  'Locked': 'Locked',
  'Switch State': 'Switch State',
  'Vehicle Information': 'Vehicle Information',
  'View QR Code': 'View QR Code',
  'Battery Information': 'Battery Information',
  'Electricity': 'Electricity',
  'Battery Health Level': 'Battery Health Level',
  'Battery Temperature': 'Battery Temperature',
  'User Information': 'User Information',
  'The User Mileage': 'The User Mileage',
  'Today s Mileage': 'Today\'s Mileage',
  'Whether to switch states': 'Whether to switch states',
  'Whether to activate the selected device': 'Whether to activate the selected device',
  'Please select the device to be activated first': 'Please select the device to be activated first',
  'Front View': 'Front View',
  'Side View': 'Side View',
  'Back View': 'Back View',
  'Electrombile': 'Electrombile',
  'Please unbind first': 'Please unbind first',
  'In operation': 'In operation',
  'Unbind': 'Unbind',
  'Are you sure to unbind the account ID': 'Are you sure to unbind the account ID',
  'The current state does not allow operations': 'The current state does not allow operations',
  'Vehicle management export': 'Vehicle management export',
  'undefined': '',
  'Equipment ID/SN': 'Equipment ID/SN',
  'Please select the equipment name': 'Please select the equipment name',
  'Equipment Name': 'Equipment Name',
  'Disable': 'Disable',
  'Frequentness': 'Frequentness',
  'Statistics': 'Statistics',
  'Electricity Statistics export': 'Electricity Statistics export',
  'Electricity Statistics': 'Electricity Statistics',
  'Period Of Time': 'Period Of Time',
  'Total Power Consumption': 'Total Power Consumption',
  'Vehicle Spec': 'Vehicle Spec',
  'Online State': 'Online State',
  'License Plates': 'License Plates',
  'Operation Record': 'Operation Record',
  'Command Number': 'Command Number',
  'Please enter command number': 'Please enter command number',
  'Operating Account': 'Operating Account',
  'Please enter operating account': 'Please enter operating account',
  'Reason For Delivery': 'Reason For Delivery',
  'State': 'State',
  'Operation Type': 'Operation Type',
  'Creation time': 'Creation time',
  'Execution Time': 'Execution Time',
  'Update Time': 'Update Time',
  'Equipment Information': 'Equipment Information',
  'User Mileage': 'User Mileage',
  'ECU Information': 'ECU Information',
  'Hardware Version': 'Hardware Version',
  'Software Version': 'Software Version',
  'ECU Battery Voltage': 'ECU Battery Voltage',
  'Current Power': 'Current Power',
  'Current Speed': 'Current Speed',
  'Started': 'Started',
  'Restart ECU': 'Restart ECU',
  'Switch': 'Switch',
  'Wheel Lock state': 'Wheel Lock state',
  'Speed Limit Gear': 'Speed Limit Gear',
  'Backseat': 'Backseat',
  'Open': 'Open',
  'ECU Fault Code': 'ECU Fault Code',
  'No data': 'No data',
  'temperature':'temperature',
  'View': 'View',
  'Battery Type': 'Battery Type',
  'Battery Status': 'Battery Status',
  'Last update time':'Last update time',
  'Please select battery status':'Please select battery status',
  'Battery Hardware Version': 'Battery Hardware Version',
  'Battery Software Version': 'Battery Software Version',
  'Battery version':'Battery version',
  'Voltage Class': 'Voltage Class',
  'Battery SOC': 'Battery SOC',
  'Battery Health': 'Battery Health',
  'Battery Voltage': 'Battery Voltage',
  'Battery Current': 'Battery Current',
  'Battery Differential':'Battery Differential',
  'Charge state': 'Charge state',
  'Discharge state': 'Discharge state',
  'MOS Temperature': 'MOS Temperature',
  'Charge MOS state': 'Charge MOS state',
  'Discharge MOS state': 'Discharge MOS state',
  'Battery MOS status':'Battery MOS status',
  'Battery Fault Code': 'Battery Fault Code',
  'Confirm operation': 'Confirm operation',
  'Vehicle Track': 'Vehicle Track',
  'ECU Number': 'ECU Number',
  'Please enter ECU number': 'Please enter ECU number',
  'Speed Limit Gear setting': 'Speed Limit Gear setting',
  'Wheel locked': 'Wheel locked',
  'Wheel unlocked': 'Wheel unlocked',
  'Backseat locked': 'Backseat locked',
  'Charge locked': 'Charge locked',
  'Charge unlocked': 'Charge unlocked',
  'Discharge locked': 'Discharge locked',
  'Discharge unlocked': 'Discharge unlocked',
  'User operation': 'User operation',
  'Admin operation': 'Admin operation',
  'System operation': 'System operation',
  'Failure': 'Failure',
  'Processing': 'Processing',
  'Electric vehicle trajectory': 'Electric vehicle trajectory',
  'Loading': 'Loading',
  'One day at most': 'One day at most',
  'Exchange status': 'Exchange status',
  'E-Motorcycle': 'E-Motorcycle',
  'Online': 'Online',
  'Offline': 'Offline',
  'Equipment Photo': 'Equipment Photo',
  'Please enter the detail address': 'Please enter the detail address',
  'Operation Management': 'Operation Management',
  'Commodity Management': 'Commodity Management',
  'Commodity State': 'Commodity State',
  'Stocks': 'Stocks',
  'Unlimited': 'Unlimited',
  'Price': 'Price',
  'Value': 'Value',
  'Effective Time': 'Effective Time',
  'Custom': 'Custom',
  'Compulsory Purchase': 'Compulsory Purchase',
  'Currency': 'Currency',
  'Product Description': 'Product Description',
  'On Sale': 'On Sale',
  'Off Sale': 'Off Sale',
  'Swapping Service': 'Swapping Service',
  'Timer Card': 'Timer Card',
  'Measured Card': 'Measured Card',
  'Please enter the correct amount': 'Please enter the correct amount',
  'Please enter the correct number of days': 'Please enter the correct number of days',
  'Please enter the correct number of times': 'Please enter the correct number of times',
  'Please select a currency': 'Please select a currency',
  'Tips': 'Tips',

  'Normal':'Normal',
  'Error': 'Error',
  'Error Code':'Error Code',
  'Whether to confirm the switching status': 'Whether to confirm the switching status',
  'RMB': 'RMB',
  'Thai Baht': 'Thai Baht',
  'Available Times': 'Available Times',
  'Commodity Number': 'Commodity Number',
  'Commodity Type': 'Commodity Type',
  'Commodity Name': 'Commodity Name',
  'Commodity Spec': 'Commodity Spec',
  'Commodity Description': 'Commodity Description',
}



// WEBPACK FOOTER //
// ./src/i18n/language-en.js